import { ICONS } from "@utils/icons";

/**
 * Profils affichés sous la photo de profil.
 *
 * Une entrée dont l'`url` est vide n'est pas rendue : il suffit de la remplir
 * pour que le lien apparaisse, sans toucher au composant.
 */
export const SOCIAL_PROFILES = [
  {
    key: "github",
    label: "GitHub",
    url: "https://github.com/Ravic110",
    brandClass: "github",
    icon: ICONS.socialGithub,
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    // À compléter avec l'URL du profil (ex. https://www.linkedin.com/in/…).
    url: "",
    brandClass: "linkedin",
    icon: ICONS.socialLinkedin,
  },
  {
    key: "email",
    label: "Email",
    url: "mailto:andriavict@gmail.com",
    brandClass: "email",
    icon: ICONS.socialEmail,
  },
];
